<template>
  <labeled-form-control label="Medical Notes" :optional="true">
    <textarea v-model="noteText" class="form-control" cols="50" rows="5" :disabled="disabled" maxlength="4000"></textarea>
  </labeled-form-control>
</template>

<script>
import { mapState, mapMutations } from 'vuex'
import { PetNoteUploadMixin } from '@/mixins/Registration/PetNoteUploadMixin'
import { PetCacheMixin } from '@/mixins/Registration/PetCacheMixin'
import { ClientOnboardingInviteCacheMixin } from '@/mixins/Registration/ClientOnboardingInviteCacheMixin'
import LabeledFormControl from '@/components/Layout/LabeledFormControl.vue'

export default {
  name: 'PetMedicalNote',
  mixins: [PetNoteUploadMixin, PetCacheMixin, ClientOnboardingInviteCacheMixin],
  props: {
    petIndex: Number,
    disabled: Boolean
  },
  data () {
    return {
      uploaded: false
    }
  },
  computed: {
    ...mapState('ApplicationEvents', [
      'saveRegistrationEvent'
    ]),
    ...mapState('ApplicationEvents', [
      'updatePetNoteEvent'
    ]),
    petId () {
      return this.petCaches ? this.petCaches[this.petIndex].id : ''
    },
    ownerId () {
      return this.petId ? this.petId : ''
    }
  },
  watch: {
    saveRegistrationEvent () {
      this.handleUpdateEvent()
    },
    updatePetNoteEvent () {
      this.handleUpdateEvent()
    },
    petDetailsUpdated () {
      this.handleUpdateEvent()
    }
  },
  methods: {
    ...mapMutations('ClientOnboardingInvites', [
      'setUpdatedPetNote'
    ]),
    ...mapMutations('ApplicationEvents', [
      'triggerUpdatePetNote'
    ]),
    handleUpdateEvent () {
      if (this.petDetailsUpdated) {
        if (!this.uploaded && this.petIndex === this.updatePetNoteEvent) {
          this.tryUploadPetNote()
        } else if (this.petIndex === this.updatePetNoteEvent) {
          this.triggerUpdatePetNote()
        }
      }
    },
    afterAddPetNote () {
      this.afterUploadEvent()
    },
    afterUpdatePetNote () {
      this.afterUploadEvent()
    },
    afterUploadEvent () {
      this.setUpdatedPetNote(this.petId)
      this.triggerUpdatePetNote()
      this.uploaded = true
    }
  },
  created () {
    this.uploaded = this.updatedPetNotes.length > 0 ? this.updatedPetNotes.includes(this.petId) : false
  },
  components: {
    'labeled-form-control': LabeledFormControl
  }
}
</script>
